import { Injectable } from '@angular/core';

// Provide this service ONCE at the app root (e.g., AppModule.providers),
// alongside other config services like RxntIconService. It holds app-wide
// state (global popup selectors, default toast duration), so providing it
// in a lazy/feature module would create a separate instance whose state
// diverges from the root — set/get calls would appear inconsistent.
@Injectable()
export class RxntPopupConfigService {
  private globalPopupSelectorList: string[] = [];
  private defaultToastDurationMs: number = 5000;

  constructor() {
  }

  getGlobalPopupSelectors(): string[] {
    return this.globalPopupSelectorList;
  }

  setGlobalPopupSelectors(classList: string[]): void {
    this.globalPopupSelectorList = classList;
  }

  getDefaultToastDurationMs(): number {
    return this.defaultToastDurationMs;
  }

  setDefaultToastDurationMs(durationMs: number): void {
    if (Number.isNaN(durationMs) || durationMs < 0) {
      console.error(
        `RxntPopupConfigService.setDefaultToastDurationMs: ${ durationMs } is not a valid duration (expected a non-negative number, or Infinity for a sticky toast). Toasts using this default will flash and disappear instead of displaying.`,
      );
    }

    this.defaultToastDurationMs = durationMs;
  }

  getMaxZIndex(selector: string = ''): number {
    if (selector === '') {
      const globalSelectors: string[] = this.getGlobalPopupSelectors();
      selector = [ ...globalSelectors, '.dx-overlay-wrapper' ].join(', '); // add Devextreme popup
    }

    return Array.from(document.querySelectorAll(selector))
      .map(e => parseInt(window.getComputedStyle(e).zIndex))
      .filter(a => !isNaN(a))
      .sort((a, b) => a - b)
      .pop() || 0;
  }
}
